import { Tag } from "antd";

export default function ProductPackagingTag() {
  return <Tag>Product packaging</Tag>;
}
